export default __webpack_public_path__ + "static/media/JaymePolaroid.401c5398.png";